import React, { useState, useEffect } from 'react'
import axios from 'axios'

const API_URL = 'https://jupiter.grub.digital/'

const styles = {
  container: {
    padding: '0'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '16px'
  },
  card: {
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
  },
  cardImage: {
    width: '100%',
    height: '140px',
    objectFit: 'cover',
    backgroundColor: '#f3f4f6'
  },
  cardBody: {
    padding: '16px'
  },
  cardTitle: {
    fontSize: '0.95rem',
    fontWeight: 700,
    color: '#111827',
    marginBottom: '4px'
  },
  cardDescription: {
    fontSize: '0.8rem',
    color: '#6b7280',
    marginBottom: '12px',
    lineHeight: 1.4
  },
  cardPoints: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: '#006aff',
    marginBottom: '12px'
  },
  button: {
    width: '100%',
    padding: '10px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#006aff',
    color: '#fff',
    fontSize: '0.85rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'opacity 0.2s'
  },
  buttonDisabled: {
    width: '100%',
    padding: '10px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#e5e7eb',
    color: '#9ca3af',
    fontSize: '0.85rem',
    fontWeight: 600,
    cursor: 'not-allowed'
  },
  insufficientText: {
    fontSize: '0.7rem',
    color: '#ef4444',
    textAlign: 'center',
    marginTop: '4px'
  },
  empty: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#6b7280'
  },
  loading: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#6b7280'
  },
  // Modal styles
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px'
  },
  modalContent: {
    background: '#fff',
    borderRadius: '16px',
    padding: '24px',
    maxWidth: '400px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
  },
  modalTitle: {
    fontSize: '1.1rem',
    fontWeight: 700,
    color: '#111827',
    marginBottom: '16px',
    textAlign: 'center'
  },
  modalDetail: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderBottom: '1px solid #f3f4f6',
    fontSize: '0.85rem'
  },
  modalDetailLabel: {
    color: '#6b7280'
  },
  modalDetailValue: {
    fontWeight: 600,
    color: '#111827'
  },
  modalButtons: {
    display: 'flex',
    gap: '12px',
    marginTop: '20px'
  },
  modalCancel: {
    flex: 1,
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    backgroundColor: '#fff',
    color: '#6b7280',
    fontSize: '0.85rem',
    fontWeight: 600,
    cursor: 'pointer'
  },
  modalConfirm: {
    flex: 1,
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#006aff',
    color: '#fff',
    fontSize: '0.85rem',
    fontWeight: 600,
    cursor: 'pointer'
  },
  successBox: {
    textAlign: 'center',
    padding: '20px 0'
  },
  successIcon: {
    fontSize: '2.5rem',
    marginBottom: '12px'
  },
  successText: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '8px'
  },
  voucherCode: {
    display: 'inline-block',
    padding: '8px 16px',
    backgroundColor: '#f0f9ff',
    border: '1px dashed #006aff',
    borderRadius: '8px',
    fontSize: '1.1rem',
    fontWeight: 700,
    color: '#006aff',
    letterSpacing: '2px',
    marginTop: '8px'
  },
  errorText: {
    color: '#ef4444',
    fontSize: '0.85rem',
    textAlign: 'center',
    marginTop: '12px'
  }
}

function LoyaltyBenefits({ brand, token }) {
  const [benefits, setBenefits] = useState([])
  const [saldoDisponivel, setSaldoDisponivel] = useState(0)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  // Redemption modal state
  const [selectedBenefit, setSelectedBenefit] = useState(null)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [redeeming, setRedeeming] = useState(false)
  const [redeemResult, setRedeemResult] = useState(null)
  const [redeemError, setRedeemError] = useState('')

  useEffect(() => {
    if (brand && token) {
      fetchBenefits()
      fetchSaldo()
    }
  }, [brand, token])

  const fetchBenefits = async () => {
    try {
      const response = await axios.get(`${API_URL}public/fidelidade/beneficios/${brand}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (response.data && response.data.success) {
        setBenefits(response.data.data || [])
      }
    } catch (err) {
      setError('Erro ao carregar benefícios')
    } finally {
      setLoading(false)
    }
  }

  const fetchSaldo = async () => {
    try {
      const response = await axios.get(`${API_URL}public/fidelidade/saldo/${brand}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (response.data && response.data.success) {
        setSaldoDisponivel(response.data.data?.pontos_disponiveis || 0)
      }
    } catch (err) {
      // Silently fail - saldo will be 0
    }
  }

  const handleResgatar = (benefit) => {
    setSelectedBenefit(benefit)
    setShowConfirmModal(true)
    setRedeemResult(null)
    setRedeemError('')
  }

  const handleConfirm = async () => {
    if (!selectedBenefit) return
    setRedeeming(true)
    setRedeemError('')

    try {
      const response = await axios.post(
        `${API_URL}public/fidelidade/resgatar/${brand}`,
        { beneficio_id: selectedBenefit.id },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      if (response.data && response.data.success) {
        setRedeemResult(response.data.data)
        // Update local balance
        setSaldoDisponivel(response.data.data.pontos_restantes ?? (saldoDisponivel - selectedBenefit.pontos_necessarios))
      } else {
        setRedeemError(response.data?.error || 'Erro ao resgatar benefício')
      }
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.message || 'Erro ao resgatar benefício'
      setRedeemError(msg)
    } finally {
      setRedeeming(false)
    }
  }

  const handleCloseModal = () => {
    setShowConfirmModal(false)
    setSelectedBenefit(null)
    setRedeemResult(null)
    setRedeemError('')
    // Refresh benefits after redemption
    if (redeemResult) {
      fetchBenefits()
      fetchSaldo()
    }
  }

  if (loading) {
    return <div style={styles.loading}>Carregando benefícios...</div>
  }

  if (error) {
    return <div style={styles.empty}>{error}</div>
  }

  if (benefits.length === 0) {
    return (
      <div style={styles.empty}>
        <div style={{ fontSize: '2rem', marginBottom: '8px' }}>🎁</div>
        <div style={{ fontWeight: 600, marginBottom: '4px' }}>Nenhum benefício disponível</div>
        <div style={{ fontSize: '0.8rem' }}>Novos benefícios serão adicionados em breve!</div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.grid}>
        {benefits.map((benefit) => {
          const hasEnoughPoints = saldoDisponivel >= benefit.pontos_necessarios
          const pointsNeeded = benefit.pontos_necessarios - saldoDisponivel

          return (
            <div key={benefit.id} style={styles.card}>
              {benefit.imagem_url && (
                <img src={benefit.imagem_url} alt={benefit.nome} style={styles.cardImage} />
              )}
              <div style={styles.cardBody}>
                <div style={styles.cardTitle}>{benefit.nome}</div>
                {benefit.descricao && (
                  <div style={styles.cardDescription}>{benefit.descricao}</div>
                )}
                <div style={styles.cardPoints}>
                  {benefit.pontos_necessarios?.toLocaleString('pt-BR')} pontos
                </div>
                <button
                  style={hasEnoughPoints ? styles.button : styles.buttonDisabled}
                  disabled={!hasEnoughPoints}
                  onClick={() => hasEnoughPoints && handleResgatar(benefit)}
                >
                  Resgatar
                </button>
                {!hasEnoughPoints && (
                  <div style={styles.insufficientText}>
                    Faltam {pointsNeeded.toLocaleString('pt-BR')} pontos
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {/* Confirmation / Result Modal */}
      {showConfirmModal && selectedBenefit && (
        <div style={styles.modalOverlay} onClick={handleCloseModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            {!redeemResult ? (
              <>
                <div style={styles.modalTitle}>Confirmar Resgate</div>
                <div style={styles.modalDetail}>
                  <span style={styles.modalDetailLabel}>Benefício</span>
                  <span style={styles.modalDetailValue}>{selectedBenefit.nome}</span>
                </div>
                <div style={styles.modalDetail}>
                  <span style={styles.modalDetailLabel}>Pontos a deduzir</span>
                  <span style={styles.modalDetailValue}>
                    -{selectedBenefit.pontos_necessarios?.toLocaleString('pt-BR')}
                  </span>
                </div>
                <div style={styles.modalDetail}>
                  <span style={styles.modalDetailLabel}>Saldo após resgate</span>
                  <span style={styles.modalDetailValue}>
                    {(saldoDisponivel - selectedBenefit.pontos_necessarios).toLocaleString('pt-BR')} pts
                  </span>
                </div>

                {redeemError && <div style={styles.errorText}>{redeemError}</div>}

                <div style={styles.modalButtons}>
                  <button style={styles.modalCancel} onClick={handleCloseModal} disabled={redeeming}>
                    Cancelar
                  </button>
                  <button
                    style={{ ...styles.modalConfirm, opacity: redeeming ? 0.7 : 1 }}
                    onClick={handleConfirm}
                    disabled={redeeming}
                  >
                    {redeeming ? 'Resgatando...' : 'Confirmar'}
                  </button>
                </div>
              </>
            ) : (
              <div style={styles.successBox}>
                <div style={styles.successIcon}>✅</div>
                <div style={styles.successText}>Resgate realizado com sucesso!</div>
                {redeemResult.voucher_code && (
                  <>
                    <div style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '8px' }}>
                      Seu código de voucher:
                    </div>
                    <div style={styles.voucherCode}>{redeemResult.voucher_code}</div>
                  </>
                )}
                {!redeemResult.voucher_code && (
                  <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>
                    O benefício foi aplicado à sua conta.
                  </div>
                )}
                <button
                  style={{ ...styles.modalConfirm, marginTop: '20px', width: '100%' }}
                  onClick={handleCloseModal}
                >
                  Fechar
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default LoyaltyBenefits
